import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Avatar from '@material-ui/core/Avatar'
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined'
import ListItemText from '@material-ui/core/ListItemText'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import Divider from '@material-ui/core/Divider'
import Popover from '@material-ui/core/Popover'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { useAchievementsAuth } from 'lib/achievements-auth'

const useStyles = makeStyles(theme => ({
  menuItemText: {
    color: theme.palette.text.primary,
  },
  avatar: {
    width: 40,
    height: 40,
    fontSize: '0.875rem',
    backgroundColor: theme.palette.primary.main,
  },
  userInfo: {
    padding: theme.spacing(1.5, 2),
  },
  userName: {
    fontWeight: 600,
    fontSize: 14,
    color: theme.palette.text.primary,
  },
  userEmail: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
}))

const AchievementsAccountDropdown = () => {
  const classes = useStyles()
  const { user, logout, isAuthenticated } = useAchievementsAuth()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleOpenMenu = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    handleCloseMenu()
    logout()
    window.location.href = '/achievements/login'
  }

  if (!isAuthenticated) return null

  const avatarContent = user?.name
    ? user.name.charAt(0).toUpperCase()
    : user?.email
      ? user.email.charAt(0).toUpperCase()
      : 'U'

  return (
    <>
      <IconButton
        aria-label="account of current user"
        aria-controls="achievements-account-menu"
        aria-haspopup="true"
        onClick={handleOpenMenu}
      >
        <Avatar className={classes.avatar}>{avatarContent}</Avatar>
        <ExpandMoreOutlinedIcon fontSize="small" />
      </IconButton>

      <Popover
        id="achievements-account-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handleCloseMenu}
      >
        <MenuList autoFocusItem>
          <Box className={classes.userInfo}>
            <Typography className={classes.userName}>
              {user?.name || 'User'}
            </Typography>
            <Typography className={classes.userEmail}>{user?.email}</Typography>
          </Box>
          <Divider />
          <MenuItem onClick={handleLogout}>
            <ListItemText classes={{ primary: classes.menuItemText }}>
              Logout
            </ListItemText>
          </MenuItem>
        </MenuList>
      </Popover>
    </>
  )
}

export default AchievementsAccountDropdown
